"use strict";
/**
 * Types for the permission catalog, and the one check both sides need.
 *
 * The catalog *itself* is code-owned and lives on the server
 * (`apps/server/src/rbac/permissions.ts`). It is not shared, deliberately: the
 * browser must never be the thing that decides what a permission means. What
 * the browser gets is the resolved list for the acting member, handed to it in
 * the org-token response, and `can()` below so a screen can hide a button the
 * guard would refuse anyway.
 *
 * Hiding is a courtesy, not a control. Every one of these strings is checked
 * again by `RbacGuard` on the server.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPERUSER_GRANT = void 0;
exports.can = can;
exports.canAny = canAny;
exports.SUPERUSER_GRANT = '*@*';
/**
 * True only when every requested permission is held.
 *
 * No permission bypasses the list. AMBIT's note on this is worth keeping: an
 * allow-list of "harmless" permissions that skip the grant check is what let
 * any authenticated user in its predecessor set their own membership role.
 */
function can(held, ...required) {
    if (required.length === 0)
        return false;
    if (held.includes(exports.SUPERUSER_GRANT))
        return true;
    return required.every(permission => held.includes(permission));
}
/** True when any one of them is held — for "show this nav item" decisions. */
function canAny(held, ...candidates) {
    if (held.includes(exports.SUPERUSER_GRANT))
        return true;
    return candidates.some(permission => held.includes(permission));
}
//# sourceMappingURL=permissions.js.map